export const addressErrorMessagePlaced = {
  SECTION_PLACE: 'SECTION_PLACE',
  LEFT_PLACE: 'LEFT_PLACE',
  POPUP_PLACE: 'POPUP_PLACE',
  RIGHT_PLACE: 'RIGHT_PLACE'
};
